'use client';

import { useInitPolyfills } from './useInitPolyfills';

export const Polyfills = () => {
  useInitPolyfills();
  return null;
};
